module.exports = __webpack_public_path__ + "static/greenwich-food-bank-logo-6ee421b1e4f04b38fec3fd1d1b03163b.webp";